import { render, staticRenderFns } from "./OrderTypePopUp.vue?vue&type=template&id=4e90a622&scoped=true&"
import script from "./OrderTypePopUp.vue?vue&type=script&lang=js&"
export * from "./OrderTypePopUp.vue?vue&type=script&lang=js&"
import style0 from "./OrderTypePopUp.vue?vue&type=style&index=0&id=4e90a622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e90a622",
  null
  
)

export default component.exports